module.exports = __webpack_public_path__ + "img/9.F.728601b7.jpg";